module.exports = __webpack_public_path__ + "media/images/ir/profile/photo_sakurada-9cf64955e30692b09e3740a02c1320e3.jpg";